import _Box from "@mui/material/Box";
import _Card from "@mui/material/Card";
import _CardContent from "@mui/material/CardContent";
import _ExpandMore from "@mui/icons-material/ExpandMore";
import _ExpandLess from "@mui/icons-material/ExpandLess";
import _Typography from "@mui/material/Typography";
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { Button } from '../button';
import Section from './section';
import SectionCard from './section-card';
import WayPoint from './way-point';
import WayPointCard from './way-point-card';
function InstructionListContent({
  disableHeader,
  route,
  bikeStationsMap,
  instructionsShowed,
  onInstructionsShowed,
  onInstructionsHidden,
  onHighlight,
  variant
}) {
  const [sectionDetailsShowed, showSectionDetails] = useState({});
  useEffect(() => {
    if (route && !variant) {
      route.sections.forEach((_, sectionIndex) => {
        showSectionDetails({
          ...sectionDetailsShowed,
          [sectionIndex]: true
        });
      });
    } else {
      showSectionDetails({});
    }
  }, [route, instructionsShowed]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !disableHeader && /*#__PURE__*/React.createElement(StyledHeader, {
    style: {
      marginBottom: variant ? '16px' : '24px'
    }
  }, variant ? /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontSize: "1.125rem",
    fontWeight: 700,
    variant: "h6"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.routing.roadmap.title"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    variant: "h6"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.routing.roadmap.title"
  })), instructionsShowed ? /*#__PURE__*/React.createElement(Button, {
    endIcon: /*#__PURE__*/React.createElement(_ExpandLess, null),
    onClick: onInstructionsHidden,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.hide_details"
  })) : /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: !route,
    endIcon: /*#__PURE__*/React.createElement(_ExpandMore, null),
    onClick: onInstructionsShowed,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.see_details"
  })))), route && (instructionsShowed || variant) && /*#__PURE__*/React.createElement(React.Fragment, null, variant ? /*#__PURE__*/React.createElement(_Card, null, /*#__PURE__*/React.createElement(_CardContent, null, route.sections.map((_, sectionIndex) => /*#__PURE__*/React.createElement(SectionWrapper, {
    key: sectionIndex
  }, /*#__PURE__*/React.createElement(WayPoint, {
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }), /*#__PURE__*/React.createElement(Section, {
    detailsShowed: sectionDetailsShowed[sectionIndex],
    handleDetailsShowed: showed => showSectionDetails({
      ...sectionDetailsShowed,
      [sectionIndex]: showed
    }),
    handleHighlight: onHighlight,
    route: route,
    sectionIndex: sectionIndex
  }), sectionIndex === route.sections.length - 1 && /*#__PURE__*/React.createElement(WayPoint, {
    isArrival: true,
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }))))) : /*#__PURE__*/React.createElement(StyledContent, null, route.sections.map((_, sectionIndex) => /*#__PURE__*/React.createElement(SectionWrapper, {
    key: sectionIndex
  }, /*#__PURE__*/React.createElement(WayPointCard, {
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }), /*#__PURE__*/React.createElement(SectionCard, {
    detailsShowed: sectionDetailsShowed[sectionIndex],
    handleDetailsShowed: showed => showSectionDetails({
      ...sectionDetailsShowed,
      [sectionIndex]: showed
    }),
    handleHighlight: onHighlight,
    route: route,
    sectionIndex: sectionIndex
  }), sectionIndex === route.sections.length - 1 && /*#__PURE__*/React.createElement(WayPointCard, {
    isArrival: true,
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }))))));
}
export function InstructionsList({
  ...props
}) {
  const {
    instructionsShowed,
    variant
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, variant ? /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(InstructionListContent, props)) : /*#__PURE__*/React.createElement(_Card, {
    sx: {
      borderRadius: 2,
      backgroundColor: instructionsShowed ? 'transparent' : 'initial'
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_CardContent, null, /*#__PURE__*/React.createElement(InstructionListContent, props))));
}
const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 36px;

  > *:not(:first-child) {
    margin-left: 16px;
  }
`;
const StyledContent = styled.div`
  position: relative;

  &::before {
    bottom: 40px;
    border: 1px dashed #ccc;
    content: '';
    left: 11px;
    position: absolute;
    top: 32px;
  }
`;
const SectionWrapper = styled.div`
  &:not(:first-child) {
    margin: 24px 0 0 0;
  }
`;